import {CAchievement} from './CAchievement';
import {CAvatarInfo} from './CAvatarInfo';
import {CItemProperty} from './CItemProperty';
import {CKickBan} from './CKickBan';
import {CTextChat} from './CTextChat';

export const initApiNotificationHandler = () => {
  const achievement = new CAchievement();
  achievement.addReceivedToastEventListener(achievement.receive);

  const avatarInfo = new CAvatarInfo();
  avatarInfo.addReceivedAvatarInfoEventListener(avatarInfo.receive);

  const textChat = new CTextChat();
  textChat.addReceivedChatEventListener(textChat.receive);
  textChat.addReceivedPersonalChatEventListener(textChat.receivePersonal);
  textChat.addReceivedSystemChatEventListener(textChat.receive);

  const itemProperty = new CItemProperty();
  itemProperty.addReceivedPropertyChangeEventListener(itemProperty.receive);
  itemProperty.addReceivedWorldPropertyChangeEventListener(itemProperty.receiveWorld);
  itemProperty.addReceivedPersonalPropertyChangeEventListener(itemProperty.receivePersonal);

  const kickBan = new CKickBan();
  kickBan.addReceivedKickEventListener(kickBan.receive);
};
